
export const EMAIL_TEMPLATE_COLUMN = [
    {
        Header: "ID",
        Footer: "ID",
        accessor: "id",
        sticky: "id",
    },
    {
        Header: "From Email",
        Footer: "From Email",
        accessor: "fromEmail",
    },
    {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createdAt",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
   
];
